export const DEFAULT_PAGE_SIZE = 10;

export const defaultSettings = {
  current: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  showSizeChanger: true,
};
